'use client'
import {Link} from "@/i18n/routing";
import {useCommonDataContext} from '@/providers/CommonDataContext';
import {useLocale, useTranslations} from 'next-intl';
import {routing, usePathname, useRouter} from '@/i18n/routing';
import {updateCurrencyAction} from '@/actions/common';
import {useBaseLazyQuery} from '@/libs/api/baseRequests';
import {GET_PRODUCTS_BY_IDS_CART_WISHLIST_QUERY} from '@/graphql/queries';
import {parseFreshCartProducts, parseFreshWishlistProducts, parseProductsToCart} from '@/libs/product';
import {CURRENCY_DEFAULT} from '@/libs/constants/common.constants';
import {useCartContext} from '@/providers/CartContext';
import {useSearchParams} from 'next/navigation';
import {useWishlistContext} from '@/providers/WshlistContext';
import {useUserContext} from '@/providers/UserContext';
import {reloadScrollTop} from '@/libs/jquery.util';

export default function HeaderTop({ data, headerStyle, headerSize }) {
  const { common } = useCommonDataContext();
  const t = useTranslations('header');
  const currentLocale = useLocale();
  const query = useSearchParams();
  
  const currentCurrency = data?.currentCurrency ?? common?.currentCurrency;
  const router = useRouter();
  const pathname = usePathname();
  
  const { user } = useUserContext();
  const { cartProducts, updateCartLocalStorage } = useCartContext();
  const { wishlistProducts, updateWishlistLocalStorage } = useWishlistContext();
  const { fetchData } = useBaseLazyQuery(GET_PRODUCTS_BY_IDS_CART_WISHLIST_QUERY);
  
  const updateCartData = async (lang, currency) => {
    if (cartProducts.length > 0 || wishlistProducts.length > 0) {
      const { ids, productStore } = parseProductsToCart(cartProducts);
      const result = await fetchData({
        variables: {
          locale: lang,
          currency: currency ?? CURRENCY_DEFAULT,
          cartIds: ids,
          wishlistIds: wishlistProducts.map(w => w.product.id)
        }
      });
      
      if (result.data) {
        if (result.data.getProductsByIdsCartWishlist.cart.length) {
          const {freshData, totalPrice} = parseFreshCartProducts(result.data.getProductsByIdsCartWishlist.cart, productStore, user?.clientType);
          updateCartLocalStorage(freshData, totalPrice);
        }
        if (result.data.getProductsByIdsCartWishlist.wishlist.length) {
          const {freshData} = parseFreshWishlistProducts(result.data.getProductsByIdsCartWishlist.wishlist);
          updateWishlistLocalStorage(freshData);
        }
      }
    }
  }
  
  const switchLocale = async (lang) => {
    if (currentLocale === lang) return;
    
    await updateCartData(lang, currentCurrency?.title);
    // router.replace(pathname, { locale: lang });
    const allQuery = {};
    query.forEach((value, key) => {
      allQuery[key] = value;
    });
    router.replace({
      pathname,
      query: allQuery
    }, { locale: lang });
    
    reloadScrollTop();
  }
  
  const changeCurrency = async (item) => {
    if (item.title === currentCurrency?.title) return;
    
    await updateCartData(currentLocale, item.title);
    await updateCurrencyAction(item.title);
  }
  
  return (
    <div
      className={`ltn__header-top-area ${
        headerStyle === 2 || headerStyle === 4 ? "top-area-color-white " : ""
      } ${headerSize === "lg" ? "plr--9" : ""}`}
    >
      <div
        className={` ${headerSize === "lg" ? "container-fluid" : "container"}`}
      >
        <div className="row">
          <div className="col-md-7">
            <div className="ltn__top-bar-menu">
              <ul>
                {
                  data?.contact || common?.contact
                      ? (<li>
                        <Link href={`mailto:${data?.contact?.email ?? common.contact.email}`}>
                          <i className="icon-mail"></i> {data?.contact?.email ?? common.contact.email}
                        </Link>
                      </li>)
                      : ''
                }
                {
                  data?.home || common?.home
                      ? (<li>
                        <i className="icon-placeholder"></i> {data?.home?.location ?? common.home.location}
                      </li>)
                      : ''
                }
              </ul>
            </div>
          </div>
          <div className="col-md-5">
            <div className="top-bar-right text-end">
              <div className="ltn__top-bar-menu">
                <ul>
                  <li>
                    {/* <!-- ltn__language-menu --> */}
                    <div className="ltn__drop-menu ltn__currency-menu ltn__language-menu">
                      <ul>
                        <li>
                          <span className="dropdown-toggle linkable">
                            <span className="active-currency">{t(`locale.${currentLocale}`)}</span>
                          </span>
                          <ul>
                            {
                              routing.locales.map((item) => (
                                  <li key={item}>
                                    <span
                                        className={`linkable ${currentLocale === item ? 'link-active bold' : ''}`}
                                        onClick={async () => {
                                          await switchLocale(item)
                                        }}
                                    >{t(`locale.${item}`)}</span>
                                  </li>
                              ))
                            }
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </li>
                  {' '}
                  {
                    Array.isArray(data?.currencies) && data?.currencies?.length > 0 && currentCurrency
                        ? (
                            <li>
                              <div className="ltn__drop-menu ltn__currency-menu ltn__language-menu ltn__hide-before">
                                <ul>
                                  <li>
                                    <span className="dropdown-toggle cursor-pointer">
                                      <span className="active-currency">{t(`currency.short.${currentCurrency.title}`)}</span>
                                      <span className="currency-sign">{ currentCurrency.symbol }</span>
                                    </span>
                                    <ul>
                                      {
                                        data.currencies.map((item, i) => (
                                            <li key={i}>
                                              <span
                                                  className={`linkable ${item.title === currentCurrency.title ? 'link-active bold' : ''}`}
                                                  onClick={async () => {
                                                    await changeCurrency(item);
                                                  }}
                                              >{t(`currency.long.${item.title}`)}</span>
                                            </li>
                                        ))
                                      }
                                    </ul>
                                  </li>
                                </ul>
                              </div>
                            </li>
                        ) : ''
                  }
                  {
                    Array.isArray(data?.socialLinks) && data?.socialLinks?.length > 0
                        ? (
                            <li className="d-none d-big-inline-block">
                              <div className="ltn__social-media">
                                <ul>
                                  {
                                    data.socialLinks.map((item, i) => (
                                        <li key={i}>
                                          <Link
                                              href={item.url}
                                              title={item.title}
                                              target="_blank"
                                          >
                                            <i className={item.icon}></i>
                                          </Link>
                                        </li>
                                    ))
                                  }
                                </ul>
                              </div>
                            </li>
                        ) : Array.isArray(common?.socialLinks) && common?.socialLinks?.length > 0
                            ? (
                                <li className="d-none d-big-inline-block">
                                  <div className="ltn__social-media">
                                    <ul>
                                      {
                                        common.socialLinks.map((item, i) => (
                                            <li key={i}>
                                              <Link
                                                  href={item.url}
                                                  title={item.title}
                                                  target="_blank"
                                              >
                                                <i className={item.icon}></i>
                                              </Link>
                                            </li>
                                        ))
                                      }
                                    </ul>
                                  </div>
                                </li>
                            ) : ''
                  }
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
